import { cn } from "./utils";

interface SkeletonProps extends React.ComponentProps<"div"> {
  delay?: number;
}

function Skeleton({ className, delay = 0, style, ...props }: SkeletonProps) {
  return (
    <div
      data-slot="skeleton"
      className={cn("skeleton-shimmer rounded-md", className)}
      style={{
        backgroundColor: 'var(--muted)',
        position: 'relative',
        overflow: 'hidden',
        animationDelay: `${delay}ms`,
        ...style,
      }}
      {...props}
    />
  );
}

export { Skeleton };
